import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { LogsEnums, LogsQuery } from 'dashboard-services/api/logs';
import Query from 'dashboard-services/api/Query';
import { ErrorBoundary } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';
import { GAUtils } from 'utils';

import { useMutation } from '@tanstack/react-query';

const useSendLog = ({ getQueryBuilder }) =>
  useMutation({
    ...LogsQuery.QUERIES.send(
      getQueryBuilder,
      {
        logger: LogsEnums.LOGGER.EXCEL,
        level: LogsEnums.LOG_LEVEL.ERROR,
      }
    )
  })

const ErrorBoundaryLocal = ({ ...props }) => {
  const dispatch = useDispatch(),
        userName = useSelector(state => state.settingsState.userName),
        version = properties.version,
        getQueryBuilder = useCallback(() => 
          new Query.Builder(dispatch(getApiConfig()))
            .withFetching(false)
            .withShouldDisplayError(false)
        , [dispatch]),
        { mutateAsync: sendErrorLogCall } = useSendLog({ getQueryBuilder }),
        sendErrorLog = useCallback(({ message, userName }) => {
          dispatch(GAUtils.sendEvent({ category: "error", label: message, fatal: true, action: "error" }))
          return sendErrorLogCall({ message: "(ErrorBoundary)" + message, userName })
        }, [dispatch, sendErrorLogCall]),
        accessGetApiConfig = useCallback(() => dispatch(getApiConfig()), [dispatch])

  return (
    <ErrorBoundary
        {...props}
        accessGetApiConfig={accessGetApiConfig}
        sendErrorLog={sendErrorLog}
        userName={userName}
        version={version}
    />
  )
}

export default ErrorBoundaryLocal;